function initCampaignSliders() {
  // 상품 이미지 슬라이더 — 항상 1개씩 표시 (정사각형 영역)
  document.querySelectorAll('[data-campaign-product-slider]').forEach(function (el) {
    var scrollbarEl = el.querySelector('.swiper-scrollbar');

    new Swiper(el, {
      slidesPerView: 1,
      spaceBetween: 0,
      threshold: 10,
      scrollbar: {
        el: scrollbarEl,
        draggable: true,
        hide: false,
      },
    });
  });

  // 이미지 슬라이더 — 높이 통일, 간격 없이 풀
  document.querySelectorAll('[data-campaign-image-slider]').forEach(function (el) {
    var slidesMobile = parseFloat(el.dataset.slidesMobile) || 1.5;
    var slidesDesktop = parseFloat(el.dataset.slidesDesktop) || 3;
    var scrollbarEl = el.querySelector('.swiper-scrollbar');

    new Swiper(el, {
      slidesPerView: slidesMobile,
      spaceBetween: 0,
      threshold: 10,
      freeMode: {
        enabled: true,
        sticky: false,
        momentumBounce: true,
      },
      scrollbar: {
        el: scrollbarEl,
        draggable: true,
        hide: false,
      },
      breakpoints: {
        750: {
          slidesPerView: slidesDesktop,
          spaceBetween: 0,
        },
      },
    });
  });
}

document.addEventListener('DOMContentLoaded', initCampaignSliders);
